import React from 'react';
import { Platform } from 'react-native';
import { Stack, type NativeStackNavigationOptions } from 'expo-router';
import { useRegisterScreenOptions } from './ScreenOptionsContext';
import { useIsLargeScreen } from '@/hooks/useIsLargeScreen';

interface ExtendedScreenOptions extends NativeStackNavigationOptions {
  headerBackgroundContent?: React.ReactNode;
  inlineTabsBar?: React.ReactNode;
  hideTitle?: boolean;
  hideBackButton?: boolean;
  backButtonOnImage?: boolean;
}

interface ScreenHeaderProps {
  options: ExtendedScreenOptions;
}

export function ScreenHeader({ options }: ScreenHeaderProps) {
  const isLargeScreen = useIsLargeScreen();

  // Only consumers of the screen-options registry are LargeScreenTitleBar
  // (large screens, all platforms) and WebDocumentTitle (web, all sizes).
  // On native mobile, MobileHeader reads options from props.options directly,
  // so registering would re-render the entire stack subtree on every focused
  // screen render and stall navigation transitions.
  const shouldRegister = isLargeScreen || Platform.OS === 'web';
  useRegisterScreenOptions(options, shouldRegister);

  const { headerBackgroundContent, inlineTabsBar, hideBackButton, backButtonOnImage, ...nativeOptions } =
    options;

  return isLargeScreen ? null : <Stack.Screen options={nativeOptions} />;
}
